import { render, staticRenderFns } from "./UserPanel.vue?vue&type=template&id=0c026ec2"
import script from "./UserPanel.vue?vue&type=script&lang=js"
export * from "./UserPanel.vue?vue&type=script&lang=js"
import style0 from "./UserPanel.vue?vue&type=style&index=0&id=0c026ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports